
import { Component, Prop, Vue } from 'vue-property-decorator'

import sanitizeHtml from 'sanitize-html'

@Component({})
export default class BacTable extends Vue {
  @Prop({ default: [] }) headers!: any[]
  @Prop({ default: [] }) items!: []
  @Prop({ default: 10 }) itemsPerPage!: number;
  @Prop({ default: false }) hideDefaultFooter!: boolean;

  get sanitizeHeaders () {
    return this.headers.filter(header => header.sanitize)
  }
}
